import { ICellRendererComp, ICellRendererParams } from '@ag-grid-community/core';

export class StructureRenderer implements ICellRendererComp {
  params: ICellRendererParams;

  eGui: HTMLElement;

  init(params: ICellRendererParams) {
    this.params = params;
    this.eGui = document.createElement('div');
    const sparkLine = document.createElement('spark-line');
    sparkLine.style.display = 'block';
    sparkLine.style.cursor = 'pointer';
    sparkLine.style.width = '100%';
    sparkLine.style.height = '40px';
    this.eGui.append(sparkLine);
  }

  getGui() {
    return this.eGui;
  }

  onColumnResized() {}

  refresh() {
    return true;
  }
}
